import React, { CSSProperties } from 'react';
import {
	itemContainer, iconAfterContainer, iconBeforeStyles, labelLinkSidebar, linkBaseStyle,
	linkBaseStyleDisabled, linkContainer, linkSideBarStyle,
} from './styles';
import { StyledLink as LinkBW } from 'baseui/link';
import { Icon } from '../icon';
import { IDummyProps, IOpenInterface } from './types';
import { withPermissionsProps } from '../../../Utilities/hoc/withPermissions';
import { styled, useStyletron } from 'styletron-react';

type EpoType = IDummyProps & withPermissionsProps;

// TODO: Review all component conditions and boilerplate code.

export const View = (props: EpoType & IOpenInterface) => {
	const {
		allowed,
		iconColor = 'var(--epods--color-ds-dark)',
		iconBefore,
		iconAfter,
		displayMode,
		collapsed,
		bold,
		htmlFor,
		...rest
	} = props;

	const [css] = useStyletron();
	const Container = styled('span', linkContainer);
	const ItemContainer = styled('div', itemContainer(!!collapsed))
	const IconAfterContainer = styled('span', iconAfterContainer);

	if (allowed === false) {
		return (
			<Container>
				{props.navLink ? (
					// TODO: recover conditional router, check depenendencies, do we want add react-router as a peer-dependency for the developers?
					// <NavLink {...rest.navLink}>{props.navLink.label}</NavLink>
					<></>
				) : (
						// @ts-ignore
						<LinkBW
							key={props.key || 1} // TODO: is it really neccessary?
							href={props.url}
							className={css(linkBaseStyleDisabled)}
							tabIndex={props.tabIndex || 0}
							title={props.title || props.label || ''}
							{...rest}
						>
							<ItemContainer>
								{iconBefore && (
									<Icon
										for={htmlFor}
										icon={iconBefore}
										color={iconColor}
										style={iconBeforeStyles(htmlFor, props.label, !!iconAfter)}
									/>
								)}
								{props.label ? props.label : props.children}
								{iconAfter && htmlFor == 'sideBar' ? (
									<IconAfterContainer $itemHasLabel={!!props.label}>
										<Icon icon={iconAfter} color={iconColor} />
									</IconAfterContainer>
								) : (
										<Icon icon={iconAfter as any} color={iconColor} />
									)}
							</ItemContainer>
						</LinkBW>
					)}
			</Container>
		);
	} else {
		const labelIsPresented = props.label || props.children;

		return (
			<Container>
				{props.navLink ? (
					// TODO: recover conditional router, check depenendencies, do we want add react-router as a peer-dependency for the developers?
					<></>
				) : (
						// @ts-ignore
						<LinkBW
							key={props.key || 1}
							href={props.url}
							style={(htmlFor === 'sideBar' ? linkSideBarStyle : linkBaseStyle(props)) as CSSProperties}
							tabIndex={props.tabIndex || 0}
							title={props.title || props.label || ''}
							{...rest}
						>
							<ItemContainer>
								{iconBefore && (
									<Icon
										for={htmlFor}
										icon={iconBefore}
										color={iconColor}
										style={iconBeforeStyles(htmlFor, props.label, !!iconAfter)}
									/>
								)}

								{labelIsPresented && (
									<div className={htmlFor === 'sideBar' ? css(labelLinkSidebar(!iconAfter)) : undefined}>
										{props.label ? props.label : props.children}
									</div>
								)}
								{iconAfter && htmlFor === 'sideBar' ? (
									<IconAfterContainer $itemHasLabel={!!props.label}>
										<Icon
											icon={iconAfter}
											color="var(--epods--color-text-ds-blue)"
											style={!props.label ? { paddingLeft: 0 } : undefined}
										/>
									</IconAfterContainer>
								) : (
										<Icon icon={iconAfter || ''} color="var(--epods--color-text-ds-blue)" />
									)}
							</ItemContainer>
						</LinkBW>
					)}
			</Container>
		);
	}
};
